import React from 'react';
import RabenLogo from 'src/images/raben-logo-removebg.png';
import companyIcon from '../../../../images/company.png';
import { CompanyBox, VerticalLine, Wrapper } from './index.styles';
import { LogosContainer } from 'src/views/Pages/RegisterRaben/components/Header/index.styles';
import { Box } from '@mui/system';
import { Link } from 'react-router-dom';
import Logo from '../../Logo';
import { Divider } from '@mui/material';

export default function SurveyHeader({ companyName }: { companyName: string }) {
  return (
    <Wrapper>
      <LogosContainer>
        <Box sx={{ mt: '12px' }}>
          <Link to="/">
            <Logo width={195} height={52} />
          </Link>
        </Box>
        <Divider
          orientation="vertical"
          flexItem
          sx={{ ml: '40px', mr: '8px', borderRightWidth: '2px' }}
        />
        <img src={RabenLogo} width="266px" height="120px" />

        <Divider
          orientation="vertical"
          flexItem
          sx={{ ml: '40px', mr: '8px', borderRightWidth: '2px' }}
        />
        <CompanyBox>
          <img src={companyIcon} alt="company logo" />
          <span>{companyName}</span>
        </CompanyBox>
      </LogosContainer>
    </Wrapper>
  );
}
